/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SchoolBell-E API
 * SchoolBell 레거시 플랫폼 리소스 OAuth AS + RS
 * OpenAPI spec version: 1.0
 */

export type OAuthSubjectType = typeof OAuthSubjectType[keyof typeof OAuthSubjectType];


export const OAuthSubjectType = {
  org: 'org',
  user: 'user',
} as const;
